import React from 'react';
import ExpandableWrapper from '../ExpandableWrapper';
import { useIntl } from 'react-intl';
import useExpandable from 'Hooks/useExpandable';
import { Wrapper } from './styled';
import ActionBar from 'Screens/Credentials/components/ActionBar';
import DetailTable from './components';

const Credentials = () => {
  const intl = useIntl();
  const isExpanded = useExpandable('credentials', 'credentials', true);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.credentials' }) } tab={ 'credentials' } id={ 'credentials' }>
        <Wrapper>
            <ActionBar />
            <DetailTable />
        </Wrapper>
    </ExpandableWrapper>
  );
};

export default Credentials;
